function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M10.5 4.83v12.28c0 .82-.52 1.51-1.25 1.77a1.773 1.773 0 01-1.5-.1c-.61-.31-1.03-.94-1.03-1.67V9.56h-.94A3.79 3.79 0 012 5.78c0-1.04.42-1.98 1.11-2.67C3.8 2.42 4.74 2 5.78 2h1.89c1.55 0 2.83 1.28 2.83 2.83z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.78 7.47c-.93 0-1.69-.76-1.69-1.7s.76-1.69 1.69-1.69c.41 0 .75.34.75.75s-.34.75-.75.75a.19.19 0 00-.19.19c0 .1.09.2.19.2.41 0 .75.34.75.75s-.34.75-.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 5.78c0 2.08-1.7 3.78-3.78 3.78h-.94v7.55c0 .73-.42 1.36-1.03 1.67a1.773 1.773 0 01-1.5.1c-.73-.26-1.25-.95-1.25-1.77V4.83A2.84 2.84 0 0116.33 2h1.89c1.04 0 1.98.42 2.67 1.11.69.69 1.11 1.63 1.11 2.67z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.22 7.47c-.41 0-.75-.34-.75-.75s.34-.75.75-.75c.11 0 .19-.09.19-.2a.19.19 0 00-.19-.19c-.41 0-.75-.34-.75-.75s.34-.75.75-.75a1.694 1.694 0 010 3.39zM9.25 18.88V22c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3.22a1.773 1.773 0 001.5.1zm7-.1V22c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3.12a1.773 1.773 0 001.5-.1z"
})));